import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { isDefined } from "csi/utility/coreUtility";
import { Box, FlexColumn, TextField } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CheckboxOption from "./CheckboxOption";
import css from "./CustomViewOptions.module.css";
import DataSheetCustomViewOptionsStore from "./DataSheetCustomViewOptionsStore";
import SelectOption from "./SelectOption";

const DataSheetViewOptions: FunctionComponent = observer(function DataSheetViewOptions() {
	const { optionsStore } = useCustomViewDialogStore();
	const loc = useLocale();

	const {
		dataSheetDropDownOptions,
		options,
		setCanvasNotesOrientation,
		setCanvasWithProperties,
		showCanvasWithPropertiesHeight,
		toggleCollapsedViewMainOptions,
		viewMainOptionsCollapse,
	} = optionsStore as DataSheetCustomViewOptionsStore;

	const {
		canvasCommentsOrientations,
	} = dataSheetDropDownOptions;

	const {
		canvasCommentsOrientation,
		canvasWithProperties,
		canvasWithPropertiesHeight,
	} = options;

	return (
		<CustomViewOptionCustomSection
			collapsed={viewMainOptionsCollapse}
			dataCsiAutomation="CustomViewDataSheetOptions"
			onCollapse={toggleCollapsedViewMainOptions}
			titleRes="CustomViewDataSheetOptions"
		>
			{isDefined(canvasCommentsOrientation) && (
				<SelectOption
					dataCsiAutomation="CustomViewDataSheetCanvasNotesOrientation"
					res="CustomViewDataSheetCanvasNotesOrientation"
					selectProps={{
						onChange: setCanvasNotesOrientation,
						options: canvasCommentsOrientations,
						value: canvasCommentsOrientations.find((item) => item.id === canvasCommentsOrientation.toString()),
					}}
				/>
			)}
			{isDefined(canvasWithProperties) && (
				<CheckboxOption
					dataCsiAutomation="CustomViewDataSheetCanvasWithProperties"
					label="CustomViewDataSheetCanvasWithProperties"
					onChange={setCanvasWithProperties}
					optionValue={canvasWithProperties}
					paddingLeft={0}
				/>
			)}
			{showCanvasWithPropertiesHeight && (
				<Box className={css.container}>
					<FlexColumn 
						className={css.optionLeft}
						data-csi-automation="CustomViewDataSheetCanvasWithPropertiesHeight"
					>
						<TextField
							defaultValue={canvasWithPropertiesHeight}
							res="CustomViewDataSheetCanvasWithPropertiesHeight"
						/>
					</FlexColumn>
				</Box>
			)}
		</CustomViewOptionCustomSection>
	);
});

export = DataSheetViewOptions;